// extracted by mini-css-extract-plugin
export default {"range":"_range_FR6OlN","labels":"_labels_lPpPzQ","label":"_label_+l-ihH"};